// Mirrors rtapp-back domain/contact.py INDIAN_MOBILE; spaces and dashes are ignored.
const INDIAN_MOBILE = /^(?:\+?91|0)?[6-9]\d{9}$/;
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isIndianMobile = (value: string) => INDIAN_MOBILE.test(value.replace(/[\s-]/g, ''));

export const isEmail = (value: string) => EMAIL.test(value.trim());
